globalThis["__sentryRewritesTunnelPath__"] = undefined;
globalThis["SENTRY_RELEASE"] = {"id":"dPBqpGpmLF0s9rrh2GD4c"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "";
import * as Sentry from '@sentry/nextjs';

const CI_PIPELINE_ID = process.env.NEXT_PUBLIC_CI_PIPELINE_ID || 'local';
const COMMIT_HASH = process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA || 'local';

const IGNORE_MESSAGES: (string | RegExp)[] = [
  // Browser quirks
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',

  // Network / connectivity
  'Failed to fetch',
  'NetworkError when attempting to fetch resource',
  'Load failed',
  'Network request failed',
  'The operation was aborted',
  'cancelled',
  /^AbortError/,

  // Opaque throws без стека
  'Non-Error promise rejection captured',
];

const CHUNK_LOAD_PATTERNS: RegExp[] = [
  /ChunkLoadError/,
  /Loading( CSS)? chunk \d+ failed/i,
  /Importing a module script failed/,
  /error loading dynamically imported module/i,
  /Failed to fetch dynamically imported module/i,
];

const HYDRATION_PATTERNS: RegExp[] = [
  /Hydration/i,
  /There was an error while hydrating/i,
  /Text content does not match server-rendered HTML/i,
  /The server could not finish this Suspense boundary/i,
  /Suspense boundary received an update before it finished hydrating/i,
];

const DENY_URLS: RegExp[] = [
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-(web-)?extension:\/\//i,
];

const setSentryUserData = (data: {
  email: string;
  role: string;
}) => {
  Sentry.setUser(data);
};

Sentry.init({
  dsn: 'https://fdc415271eaa45c7860004f15daa619f@sentry.eddev.dev/8',
  debug: false,
  release: COMMIT_HASH,
  tracesSampleRate: 0.05,
  enableTracing: true,
  autoSessionTracking: true,
  ignoreErrors: [
    ...IGNORE_MESSAGES,
    ...CHUNK_LOAD_PATTERNS,
    ...HYDRATION_PATTERNS,
  ],
  denyUrls: DENY_URLS,
  integrations: [
    Sentry.replayIntegration({
      beforeErrorSampling: (event) => event.level === 'fatal',
      useCompression: true,
    }),
  ],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
});

Sentry.setTag('CI_PIPELINE_ID', CI_PIPELINE_ID);
Sentry.setTag('COMMIT_HASH', COMMIT_HASH);

window.setSentryUserData = setSentryUserData;
